//import NumberingUtils from 'Editor/services/_Common/NumberingUtils';
import { ELEMENTS } from 'Editor/services/consts';

export const DEFAULT_CAPTION = {
  nf: 'd',
  p: 'below',
  ls: ELEMENTS.ParagraphElement.BASE_STYLES.FIGURE_CAPTION,
};

export const StructureKeys = Object.freeze({
  ID: '_id',
  PARENT_ID: 'parent_id',
  STYLES: 'st',
  LISTS: 'lists',
  LIST_STYLES: 'l_st',
  CHILDNODES: 'childNodes',
  BLOCK_PROPERTIES: 'blkProps',
  CAPTIONS: 'cpt',
  EXTRA: 'extra',
  TEMPLATE: 't',
  TASK_SEQUENCE: 'tsk_sq',
});
